"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OutcomeDropdown = void 0;
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var react_redux_1 = require("react-redux");
var Localize_1 = require("../../../gen-src/Localize");
var BooleanIcon_1 = require("../../img/BooleanIcon");
var CalendarClockIcon_1 = require("../../img/CalendarClockIcon");
var CalendarIcon_1 = require("../../img/CalendarIcon");
var NumberContinousIcon_1 = require("../../img/NumberContinousIcon");
var SpatialIcon_1 = require("../../img/SpatialIcon");
var TextIcon_1 = require("../../img/TextIcon");
var SubspaceSlice_1 = require("../../store/slice/SubspaceSlice");
var PredictiveModelThunk_1 = require("../../store/thunk/PredictiveModelThunk");
var ObjectiveSelectionStyles_1 = require("../../styles/ObjectiveSelectionStyles");
var TestIds_1 = require("../../util/TestIds");
var Utils_1 = require("../../util/Utils");
var StateSelectors_1 = require("../StateSelectors");
var getIcon = function (dataType) {
    switch (dataType) {
        case Utils_1.PrepDataType.Integer:
        case Utils_1.PrepDataType.Real:
            return React.createElement(NumberContinousIcon_1.NumberContinousIcon, null);
        case Utils_1.PrepDataType.String:
            return React.createElement(TextIcon_1.TextIcon, null);
        case Utils_1.PrepDataType.DateTime:
            return React.createElement(CalendarClockIcon_1.CalendarClockIcon, null);
        case Utils_1.PrepDataType.Date:
            return React.createElement(CalendarIcon_1.CalendarIcon, null);
        case Utils_1.PrepDataType.Boolean:
            return React.createElement(BooleanIcon_1.BooleanIcon, null);
        case Utils_1.PrepDataType.Spatial:
            return React.createElement(SpatialIcon_1.SpatialIcon, null);
        default:
            return React.createElement("div", null);
    }
};
var getOutcomeList = function (outcomes) {
    var listItems = [];
    if (outcomes && outcomes.length > 0) {
        outcomes.forEach(function (outcome) {
            if ((0, Utils_1.isValidPrepTypeToTrain)(outcome.dataType)) {
                listItems.push({
                    content: (React.createElement("div", { className: ObjectiveSelectionStyles_1.OutcomeDropdownItemStyle },
                        React.createElement("div", { className: ObjectiveSelectionStyles_1.OutcomeDropdownDataTypeIconStyle }, getIcon(outcome.dataType)),
                        React.createElement("div", { className: ObjectiveSelectionStyles_1.OutcomeDropdownValueStyle }, outcome.name))),
                    value: outcome.name,
                });
            }
        });
    }
    return listItems;
};
var OutcomeDropdown = function (props) {
    var dispatch = (0, react_redux_1.useDispatch)();
    var selectedObjective = (0, react_redux_1.useSelector)(StateSelectors_1.objectiveSelector);
    var domainRetrievalStatus = (0, react_redux_1.useSelector)(StateSelectors_1.domainRetrievalStatusSelector);
    var domainError = (0, react_redux_1.useSelector)(StateSelectors_1.selectOutcomeDomainError);
    var getOutcomeAndPredictionType = function (dataType, domain) {
        if (dataType === Utils_1.PrepDataType.Integer || dataType === Utils_1.PrepDataType.Real) {
            if (domain.length === 2) {
                return [Utils_1.OutcomeType.Text, Utils_1.PredictionType.Binary];
            }
            else if (domain.length > 2) {
                return [Utils_1.OutcomeType.Number, Utils_1.PredictionType.Regression];
            }
        }
        else if ((dataType === Utils_1.PrepDataType.Boolean || dataType === Utils_1.PrepDataType.String) && domain.length === 2) {
            return [Utils_1.OutcomeType.Text, Utils_1.PredictionType.Binary];
        }
        return [Utils_1.OutcomeType.Undefined, Utils_1.PredictionType.Undefined];
    };
    var handleChangeCallback = function (value) {
        var _loop_1 = function (trainingOutcome) {
            if (trainingOutcome.name === value) {
                dispatch((0, SubspaceSlice_1.updateDomainRetrievalStatus)(Utils_1.DomainRetrievalStatus.Retrieving));
                dispatch((0, SubspaceSlice_1.updateObjective)({ value: trainingOutcome.name, type: 'outcomeField' }));
                if (trainingOutcome.cleanStep && trainingOutcome.cleanStep.runAnalyzerAsync) {
                    //maxBins can be set to 3 setting it to 100 because of this bug- https://tfs.tsi.lan/tfs/DefaultCollection/Tableau-Dev/_workitems/edit/1388480
                    trainingOutcome.cleanStep.runAnalyzerAsync('getFullDomain', { columnName: trainingOutcome.name, maxBins: 100 }).then(function (result) {
                        getAndDispatchObjective(trainingOutcome.dataType, result, value);
                    }, function (reason) {
                        console.log(reason);
                        dispatch((0, SubspaceSlice_1.updateObjective)({ value: [], type: 'domain' }));
                        dispatch((0, PredictiveModelThunk_1.updateModel)({ objectiveSuccessValue: '', objectiveFailureValue: '' }));
                        dispatch((0, SubspaceSlice_1.updateDomainRetrievalStatus)(Utils_1.DomainRetrievalStatus.Error));
                    });
                }
                else {
                    dispatch((0, SubspaceSlice_1.updateObjective)({ value: [], type: 'domain' }));
                    dispatch((0, PredictiveModelThunk_1.updateModel)({ objectiveSuccessValue: '', objectiveFailureValue: '' }));
                    dispatch((0, SubspaceSlice_1.updateDomainRetrievalStatus)(Utils_1.DomainRetrievalStatus.Error));
                    dispatch((0, SubspaceSlice_1.setOutcomeDomainError)(Localize_1.Messages.domainErrorDataSourceConnectionLost()));
                }
            }
        };
        for (var _i = 0, _a = props.outcomes; _i < _a.length; _i++) {
            var trainingOutcome = _a[_i];
            _loop_1(trainingOutcome);
        }
    };
    var getAndDispatchObjective = function (dataType, result, selectValue) {
        var success = result['success'];
        var domain = [];
        if (success) {
            var bins = result['result']['bins'];
            bins &&
                bins.forEach(function (bin) {
                    bin['startValue'] !== null && domain.push(bin['startValue'].toString());
                });
            //this will get the OutcomeType and PredictionType based upon prep datatype and domain values
            var OutcomeAndPredictionType = getOutcomeAndPredictionType(dataType, domain);
            if (OutcomeAndPredictionType[0] === Utils_1.OutcomeType.Undefined) {
                domain.length < 2
                    ? dispatch((0, SubspaceSlice_1.setOutcomeDomainError)(Localize_1.Messages.singleClassFieldNotSupportedForTraining()))
                    : dispatch((0, SubspaceSlice_1.setOutcomeDomainError)(Localize_1.Messages.multiClassFieldNotSupportedForTraining()));
                dispatch((0, SubspaceSlice_1.updateDomainRetrievalStatus)(Utils_1.DomainRetrievalStatus.Error));
            }
            else {
                dispatch((0, SubspaceSlice_1.updateObjective)({ value: OutcomeAndPredictionType[0], type: 'outcomeType' }));
                //TO-DO: predictionType would be removed
                dispatch((0, SubspaceSlice_1.updateObjective)({ value: OutcomeAndPredictionType[1], type: 'predictionType' }));
                //we only need the domain value if the prediction type is binary, initialize them to success and failure value
                var modelUpdate = void 0;
                if (domain.length === 2) {
                    dispatch((0, SubspaceSlice_1.updateObjective)({ value: domain, type: 'domain' }));
                    dispatch((0, SubspaceSlice_1.updateObjective)({ value: domain[0], type: 'successValue' }));
                    dispatch((0, SubspaceSlice_1.updateObjective)({ value: domain[1], type: 'failureValue' }));
                    modelUpdate = {
                        objectiveTargetField: selectValue,
                        objectiveTargetFieldType: OutcomeAndPredictionType[0],
                        objectiveSuccessValue: domain[0],
                        objectiveFailureValue: domain[1],
                    };
                }
                else {
                    modelUpdate = {
                        objectiveTargetField: selectValue,
                        objectiveTargetFieldType: OutcomeAndPredictionType[0],
                        objectiveSuccessValue: '',
                        objectiveFailureValue: '',
                    };
                }
                dispatch((0, PredictiveModelThunk_1.updateModel)(modelUpdate));
                dispatch((0, SubspaceSlice_1.updateDomainRetrievalStatus)(Utils_1.DomainRetrievalStatus.Retrieved));
            }
        }
        else {
            var domainError_1 = result['errorMessage'];
            console.log(domainError_1);
            switch (domainError_1) {
                case Utils_1.GetDomainErrors.StepNotFound:
                    dispatch((0, SubspaceSlice_1.setOutcomeDomainError)(Localize_1.Messages.domainErrorStepNotFound()));
                    break;
                case Utils_1.GetDomainErrors.RunFailed:
                    dispatch((0, SubspaceSlice_1.setOutcomeDomainError)(Localize_1.Messages.domainErrorRunFailed()));
                    break;
                case Utils_1.GetDomainErrors.ColumnNotFound:
                    dispatch((0, SubspaceSlice_1.setOutcomeDomainError)(Localize_1.Messages.domainErrorMissingColumn({ value: selectValue })));
                    break;
                case Utils_1.GetDomainErrors.Unknown:
                    dispatch((0, SubspaceSlice_1.setOutcomeDomainError)(Localize_1.Messages.domainErrorUnknown()));
                    break;
                default:
                    dispatch((0, SubspaceSlice_1.setOutcomeDomainError)(Localize_1.Messages.domainErrorUnknown()));
            }
            console.log(result['errorMessage']);
            dispatch((0, SubspaceSlice_1.updateObjective)({ value: [], type: 'domain' }));
            dispatch((0, PredictiveModelThunk_1.updateModel)({ objectiveSuccessValue: '', objectiveFailureValue: '' }));
            dispatch((0, SubspaceSlice_1.updateDomainRetrievalStatus)(Utils_1.DomainRetrievalStatus.Error));
        }
    };
    return (React.createElement("div", { style: { display: 'fixed' }, className: ObjectiveSelectionStyles_1.OutcomeDropdownContainerStyle },
        React.createElement(widgets_1.SingleSelectDropdown, { label: Localize_1.Messages.outcomeFieldListTitle(), testId: TestIds_1.FIELD_DROPDONW_LIST_TEST_ID, list: React.createElement(widgets_1.LocallyFilteringList, { style: { maxHeight: 250 }, items: getOutcomeList(props.outcomes) }), onChange: function (field) {
                handleChangeCallback(field);
            }, type: widgets_1.DropdownButtonType.Outline, value: selectedObjective.outcomeField, disabled: domainRetrievalStatus === Utils_1.DomainRetrievalStatus.Retrieving, valid: domainRetrievalStatus === Utils_1.DomainRetrievalStatus.Error ? false : undefined, message: domainRetrievalStatus === Utils_1.DomainRetrievalStatus.Error && domainError }, selectedObjective.outcomeField)));
};
exports.OutcomeDropdown = OutcomeDropdown;
//# sourceMappingURL=OutcomeDropdown.js.map